export const iosScrollShouldLockAttributeName = 'data-ios-should-lock-scroll';
export const iosScrollLockedAttributeName = 'data-locked-scroll';
export const iosScrollLockedOffsetCssProp = '--ios-lock-scroll-offset';
export const isOldIOSAttributeName = 'data-is-old-ios';

// FIXME Vue 2 → Vue 3 для быстрого восстановления работы заменить
export const vmodelEvent = 'input'; // на 'modelValue:update'
export const vmodelProp = 'value'; // на 'modelValue'
